import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { UpdateBrandName, getAllYaragh } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import {DialogActions} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from 'react-bootstrap-icons';

export default function EditBrand({reGetOnBack}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [change, setChange] = useState(false);
  const [loading, setLoading] = useState(false);
  const { brandYaraghList, selectedBrandYaragh } = useSelector((state) => ({
    brandYaraghList: state.yaragh.brandYaraghList,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
  }));
  const [controls, setControls] = useSetState({
    yaraghName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      }
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  }

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(change) {
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        const { yaraghName } = controls;
        try {
          const data = {
            Id: selectedBrandYaragh.Id,
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: yaraghName.value,
          };
          await dispatch(UpdateBrandName(data));
          let selectedIndex = -1;
          brandYaraghList.map((item, index) => {
            if(item.Id === selectedBrandYaragh.Id) {
              selectedIndex = index;
            }
          })
          await reGetOnBack(false, selectedIndex)
        } catch (e) {
          showNotify({
            text: t('correctFormDataRequired'),
            customClass: "error",
          });
        }
        handleDialog();
      } else {
        setCheckValid(true);
      }
    } else {
      handleDialog();
    }
    setLoading(false);
  }

  const onEnter = () => {
    onClear();
  }

  const onClear = () => {
    setCheckValid(false);
    setFormValid({ yaraghName: true });
    setControls({ yaraghName: { value: selectedBrandYaragh.Name } });
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiIconButton
        title={<Translator id={"editBrandFitting"}/>}
        icon={<Icons.Pencil size={17}/>}
        className="fix-size"
        onClick={handleDialog}
        disabled={
            read("StypeU") === "1"
              ? !selectedBrandYaragh.IsG
              : (selectedBrandYaragh.IsG && read("yaraghRules").accessUpdate)
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p> {<Translator id="editBrandFitting" />}</p>
          </div>
          <DialogContent>
            <Grid container className="mt-1">
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index}>
                    {controls[key].type === "text" && (
                      <Input
                        loading={loading}
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        placeholder={t(key)}
                        type="text"
                        checkValid={checkValid}
                        value={controls[key].value}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

